import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { NbAccessChecker } from '@nebular/security';

// Abstracts
import { NgPostTypeProvider, NgHttpService } from '../abstracts';

// Interfaces
import { IPostType, IPostTypeProviderOptions } from 'projects/models/src/public-api';

// Environment
import { map, flatMap } from 'rxjs/operators';

@Injectable()
export class WordpressPostTypeProvider<T extends IPostType> implements NgPostTypeProvider<T> {

    constructor(private http: NgHttpService, private accessChecker: NbAccessChecker) {}

    private contentStatus(options?: IPostTypeProviderOptions<T>): Observable<IPostTypeProviderOptions<T>> {
        return this.accessChecker.isGranted('create', 'postType')
            .pipe(map((granted) => {
                return granted ? { ...options, status: ['publish', 'draft'] } as IPostTypeProviderOptions<T> : options;
            }),
        )
    }

    public get(path?: string, options?: IPostTypeProviderOptions<T>): Observable<T|T[]> {
        return this.contentStatus(options)
            .pipe(flatMap(result => {
                return this.http.get(path, null, result) as Observable<T|T[]>
            }));
    }

}
